import { AccountDto, AccountDtoPermission } from '../../interactors/gen/backendClient'

export const isAdmin = (account: AccountDto) => {
  return account.permission === AccountDtoPermission.Administrator
}
